<template>
  <el-dialog
    :title="`Phòng ${roomData.room_num} - ${roomData.room_level_name}`"
    visible
    append-to-body
    :close-on-click-modal="false"
    width="800px"
    @close="onClose"
  >
    <!-- <div style="display: flex; gap: 10px">
        <div
          v-for="item in Object.keys(ROOM_STATUS_TYPE_VALUE)"
          :key="ROOM_STATUS_TYPE_VALUE[item]"
        >
          <input
            :id="item"
            v-model="roomType"
            type="radio"
            :value="ROOM_STATUS_TYPE_VALUE[item]"
          />
          <label :for="item">{{ item }}</label
          ><br />
        </div>
      </div> -->
    <!-- DIALOG CONTENT -->
    <div>
      <!-- INFO SECTION -->
      <section>
        <InfoList :columns="3" class="info-list__container-custom">
          <InfoListLabel style="">Khách sạn</InfoListLabel>
          <InfoListValue>{{ hotelName }}</InfoListValue>
          <InfoListLabel>Trạng thái phòng</InfoListLabel>
          <InfoListValue>{{ roomStatusText }}</InfoListValue>
          <InfoListLabel>Tầng</InfoListLabel>
          <InfoListValue>{{ roomData.floors }}</InfoListValue>
          <!-- <InfoListLabel>Lorem ipsum</InfoListLabel>
            <InfoListValue>Lorem ipsum dolor sit amet. </InfoListValue>
            <InfoListLabel>Lorem ipsum</InfoListLabel>
            <InfoListValue>Lorem ipsum dolor sit amet. </InfoListValue> -->
        </InfoList>
      </section>
      <!-- END INFO SECTION -->
      <!-- AVAILABLE ROOM -->
      <!-- <template v-if="roomData.empty_room"> </template> -->
      <!-- BOOKED ROOM -->
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <div class="button-containers__left">
          <button
            v-if="roomData.ooo || roomData.oos"
            class="btn primary small outline"
            @click="fnCancelOOO"
          >
            Hủy OOO/OOS
          </button>
          <template v-if="!roomData.ooo">
            <button class="btn primary small" @click="fnSetRoomClean">
              Đặt phòng sạch
            </button>
            <button class="btn primary small" @click="fnSetRoomDirty">
              Đặt phòng bẩn
            </button>
            <!-- <button class="btn primary small" @click="fnSetRoomChecked">
              Xác nhận kiểm tra
            </button> -->
            <!-- <button class="btn primary small" @click="fnSetRoomChecked">
              Xác nhận kiểm tra
            </button> -->
            <button
              v-if="!roomData.oos"
              class="btn primary small"
              @click="fnOpenOoDialog"
            >
              Tạo OOO/OOS
            </button>
          </template>
        </div>
        <div class="button-containers__right">
          <button class="btn primary small outline" @click="onClose">
            Hủy
          </button>
        </div>

        <CreateOooOosDialog
          v-if="addDialogVisible"
          @close="fnCloseOoDialog"
          @resetData="onCreateOoo"
        />
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { dateFormatter } from '@/utils/dataFormatter'
import CreateOooOosDialog from './CreateOooOosDialog.vue'

// API REQUEST
import {
  getRoomBookingDetailApi,
  setRoomStatusApi,
  // eslint-disable-next-line no-unused-vars
  getBookingTravellerListApi,
  checkInBookingApi
} from '@/api/chamber_service/common'

import {
  // eslint-disable-next-line no-unused-vars
  deleteOooRoomApi,
  getOooOosDetailApi
} from '@/api/houseKeeper/ooo-room'

// CONSTANT
import { ROOM_STATUS_VALUE, ROOM_BOOKING_TYPE_VALUE } from '../constants'

// STORE
import { bookingDetailStore, roomInfo, roomInfoInitialState } from '../stores/'

const getDefaultOooOosDetail = () => ({
  date_from: null,
  date_to: null,
  reason_string: null
})

export default {
  components: {
    CreateOooOosDialog
  },
  props: {
    // roomType: {
    //   type: String
    //   // required: true
    // },
    // roomInfo: {
    //   type: Object
    //   // required: true
    // }
    hotelName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      roomType: 0,
      tabIndex: 1,
      tabList: [
        { label: 'Thông tin đặt phòng', value: 1 },
        { label: 'Khách', value: 2 },
        { label: 'Dịch vụ đặc biệt', value: 3 }
      ],
      dialogTitle: null,
      dialogLoading: false,
      addDialogVisible: false,
      editBookingRoomDialogVisible: false,
      bookingDetailStore,
      roomInfo,
      roomData: { ...roomInfoInitialState },
      oooOosDetail: getDefaultOooOosDetail()
    }
  },

  computed: {
    ROOM_BOOKING_TYPE_VALUE() {
      return ROOM_BOOKING_TYPE_VALUE
    },

    roomStatusText() {
      switch (this.roomInfo.room_status) {
        case ROOM_STATUS_VALUE.DIRTY:
          return 'Phòng bẩn'
        case ROOM_STATUS_VALUE.CLEAN:
          return 'Phòng sạch'
        case ROOM_STATUS_VALUE.READY:
          return 'Phòng đã kiểm tra'
        default:
          return 'transparent'
      }
    }
  },

  watch: {
    isShow(val) {}
  },

  mounted() {
    this.roomData = this.roomInfo
    if (!this.roomData.empty_room) {
      // Promise.all([this.fnGetBookingDetail(), this.fnGetBookingTravellers()])
      this.fnGetBookingDetail()
    }
    if (this.roomData.ooo || this.roomData.oos) {
      this.fnGetOooOosDetail()
    }

    // DELETE LATER
    // this.fnGetBookingDetail()
  },
  destroyed() {
    this.roomData = { ...roomInfoInitialState }
    this.oooOosDetail = getDefaultOooOosDetail()
  },
  methods: {
    dateFormatter,
    onClose() {
      this.$emit('close')
    },

    onCreateOoo() {
      this.$emit('resetData')
      this.$emit('close')
    },

    increaseRoomTypeTest() {
      this.roomType = this.roomType === 5 ? 0 : this.roomType + 1
    },

    /** If room is not empty -> Get booking detail */
    async fnGetBookingDetail() {
      await getRoomBookingDetailApi(this.roomData.sub_booking_group_id)
        .then(res => {
          Object.assign(bookingDetailStore, res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // async fnGetBookingTravellers() {
    //   await getBookingTravellerListApi(this.roomData.sub_booking_group_id)
    //     .then(res => {
    //       bookingDetailStore.travellers = res.data
    //       this.tabList[1].label = `${this.tabList[1].label} (${res.data.length})`
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },

    /** If room status is OOO/OOS -> Get OOO/OOS Info */
    async fnGetOooOosDetail() {
      await getOooOosDetailApi(this.roomData.ooo_oos_id)
        .then(res => {
          this.oooOosDetail = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnSetRoomClean() {
      setRoomStatusApi({
        room_status: ROOM_STATUS_VALUE.CLEAN,
        room_ids: [this.roomData.room_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnSetRoomDirty() {
      setRoomStatusApi({
        room_status: ROOM_STATUS_VALUE.DIRTY,
        room_ids: [this.roomData.room_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnSetRoomChecked() {
      setRoomStatusApi({
        room_status: ROOM_STATUS_VALUE.READY,
        room_ids: [this.roomData.room_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnCheckinBooking() {
      this.$vxConfirm('Xác nhận Check-in?', () => {
        checkInBookingApi([roomInfo?.sub_booking_group_id])
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + res.message)
            })
            this.$emit('resetData')
            this.$emit('close')
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: this.$t('errorMsg.' + err.response.data.message)
            })
          })
      })
    },

    onClickCheckoutBooking() {
      const route = this.$router.resolve({
        path: '/cashier/post_transaction',
        query: {
          booking_id: this.roomData.sub_booking_group_id
        }
      })
      window.open(route.href, '_blank')
    },

    fnOpenOoDialog() {
      this.addDialogVisible = true
    },

    fnCloseOoDialog() {
      this.addDialogVisible = false
    },

    fnCancelOOO() {
      deleteOooRoomApi({ id_list: [this.roomData.ooo_oos_id] })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    fnOpenEditBookingRoomDialog() {
      this.editBookingRoomDialogVisible = true
    },

    fnCloseEditBookingRoomDialog() {
      this.editBookingRoomDialogVisible = false
    },

    onClickCreateReservation() {
      const route = this.$router.resolve({
        path: '/reservation/new_reservation'
        // query: {
        //   id: this.roomData.room_id
        // }
      })
      window.open(route.href, '_blank')
    },

    onClickEditReservation() {
      const route = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          id: this.roomData.booking_code,
          action: 'edit'
        }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.button-containers {
  margin-left: 20px;
  display: flex;
  gap: 20px;
  justify-content: space-between !important;

  &__left,
  &__right {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__left {
    align-self: left;
  }

  &__right {
    align-self: right;
    justify-content: flex-end;
  }
}

.info-list__container-custom {
  border: none;
}

.tabmenu-container-custom {
  .tab-list {
    .tab-item {
      .tab-label {
        border-bottom: 1px solid $borderColor;
      }

      &:last-child {
        border-bottom: 1px solid $borderColor;
      }

      input[type='radio']:checked ~ .tab-label {
        border: 1px solid $borderColor;
        border-bottom: none;
      }
    }
  }
}
</style>
